<template>
  <div>
    <piaochuang v-if="piaochuang.title" :info="piaochuang" />
    <div class="lke-header-login">
      <div class="lke-header-bg">
        <div class="lke-header-in">
          <div class="login-top">
            <i class="el-icon-user-solid"></i>
            {{ userInfo ? "用户信息" : "用户登录" }}
          </div>
          <div class="login-fot" v-if="userInfo">
            <div class="lke-login-fot">
              <p><span>姓名：</span>{{ userInfo.name }}</p>
              <p v-if="userInfo.isEnrolled === 1">
                <span>学号：</span>{{ userInfo.sid }}
              </p>
              <p v-if="userInfo.isEnrolled === 0">
                <span>身份证号：</span>{{ userInfo.uid }}
              </p>
              <p v-if="userInfo.isEnrolled === 1">
                <span>班级：</span>{{ userInfo.className }}
              </p>
              <p v-if="userInfo.isEnrolled === 0"><span>班级：</span>暂无</p>
              <div class="lke-login-fot-fot">
                <el-button size="small" type="warning" @click="openRouter('grzxIndex')">个人中心</el-button>
                <el-button size="small" type="danger" @click="loginOut">退出登录</el-button>
              </div>
            </div>
          </div>
          <div class="login-fot" v-else>
            <div class="lke-login-button sut" @click="openLogin(0)">
              学生登录
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lke-look">
      <div class="lke-look-in">
        <div class="lke-look-l" v-loading="loading">
          <div class="lke-look-top">
            <div>新闻</div>
            <router-link to="/xwzxList" style="text-decoration: none">
              <a>更多></a>
            </router-link>
          </div>
          <div v-if="newsList.length > 0">
            <div v-for="(list, index) in newsList" :key="index">
              <div class="lke-look-l-fot" v-if="index == 0">
                <el-image style="width: 160px; height: 120px" :src="imgUrl + list.img" fit="fill"></el-image>
                <div class="lke-look-l-fot-r">
                  <router-link :to="'/xwzx/' + list._id" style="text-decoration: none">
                    <p>{{ list.title }}</p>
                  </router-link>
                  <div class="lke-look-l-fot-r-fot">
                    <span>{{ list.releaseTime | addtime }}</span>
                    <router-link :to="'/xwzx/' + list._id" style="text-decoration: none">
                      <div>了解更多>></div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="padding-left: 40px" v-else>暂无新闻</div>
        </div>
        <div class="lke-look-r" v-loading="loading">
          <div class="lke-look-top">
            <div>公告</div>
            <router-link to="/jxggList" style="text-decoration: none">
              <a>更多></a>
            </router-link>
          </div>
          <div v-if="noticeList.length > 0">
            <div class="lke-look-r-fot">
              <div v-for="(list, index) in noticeList" :key="index">
                <router-link :to="'/jxgg/' + list._id" style="text-decoration: none" v-if="index < 3">
                  <div class="lke-look-text">
                    <div class="lke-look-text-l">
                      <span>{{ list.releaseTime | noticeday }}</span>
                      <span>{{ list.releaseTime | noticeyear }}</span>
                    </div>
                    <div class="lke-look-text-r">
                      {{ list.title }}
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div style="padding-left: 40px" v-else>暂无公告</div>
        </div>
      </div>
    </div>
    <div class="lke-class" v-loading="loading">
      <div class="lke-class-in">
        <div class="lke-class-top">课程展示</div>
        <div class="lke-class-fot">
          <div class="lke-calss-tab" @click="openclassshow(list)" v-for="(list, index) in courseList" :key="index">
            <div class="lke-calss-tab-top" :style="{
              background: 'url(' + imgUrl + list.img + ')',
              'background-size': '100% 100%',
              'background-repeat': 'no-repeat',
            }"></div>
            <div class="lke-calss-tab-fot">{{ list.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lke-th-bg">
      <div class="lke-th-in">
        <div class="lke-th-top" v-loading="loading">
          <div class="lke-th-titl">名师风采</div>
        </div>
        <el-carousel :interval="4000" type="card" height="200px">
          <el-carousel-item v-for="(list, index) in teacherList" :key="index">
            <router-link :to="'/msfc/' + list._id" style="text-decoration: none">
              <div class="lke-lunbo">
                <div class="lke-lunbo-l">
                  <img :src="imgUrl + list.img" alt="" />
                </div>
                <div class="lke-lunbo-r">
                  <div class="lke-lunbo-r-top">
                    {{ list.title }}
                  </div>
                  <div class="lke-lunbo-r-fot" v-html="list.content"></div>
                </div>
              </div>
            </router-link>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <el-dialog :title="classshow.title" :visible.sync="dialogVisible" width="800px">
      <div id="video"></div>
    </el-dialog>

    <div class="lke-zhezhao" v-if="show">
      <div class="lke-zhezhao-box">
        <span>微信小程序绑定</span>
        <div style="padding-bottom: 30px">
          <img style="width: 300px; height: 300px" :src="imgUrl + system.erCode" alt="" />
        </div>
        <el-button :loading="wxLoading" type="primary" @click="getuserInfo">绑定完成，进行验证</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken, setImgUrl, setVideoUrl } from "@/utils/auth";
import { gethomeinfo } from "@/api/index";
import { userinfo } from "@/api/login";
import Player from "xgplayer";
import piaochuang from "../../components/piaochuang";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      url: "@/pages/index/assets/bird.jpeg",
      newsList: [],
      noticeList: [],
      courseList: [],
      classshow: {},
      teacherList: [],
      player: {},
      piaochuang: {},
      imgUrl: "",
      videoUrl: "",
      show: false,
      wxLoading: false,
      system: {}
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    home() {
      return this.$store.state.home;
    },
  },
  filters: {
    addtime(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    noticeday(val) {
      return moment(val).format("DD");
    },
    noticeyear(val) {
      return moment(val).format("GGGG-MM");
    },
  },
  created() {
    this.getHomeInfo();
  },
  mounted() { },
  watch: {
    dialogVisible() {
      if (this.dialogVisible === false && this.player && this.player.destroy) {
        this.player.destroy(true);
      }
    },
    home: {
      deep: true,
      handler(val) {
        if (val && val.system) {
          this.applyHomeData(val);
        }
      }
    }
  },
  methods: {
    applyHomeData(homeData) {
      this.newsList = Array.isArray(homeData.news) ? homeData.news : [];
      this.noticeList = Array.isArray(homeData.notice) ? homeData.notice : [];
      this.teacherList = Array.isArray(homeData.teacher) ? homeData.teacher : [];
      this.courseList = Array.isArray(homeData.classShow) ? homeData.classShow : [];
      this.imgUrl = homeData.system && homeData.system.qiniuCdn ? homeData.system.qiniuCdn : '';
      this.videoUrl = homeData.system && homeData.system.qiniuCdnVideo ? homeData.system.qiniuCdnVideo : '';
      this.system = homeData.system || {};
      setImgUrl(this.imgUrl);
      setVideoUrl(this.videoUrl);
      this.piaochuang = (homeData.system && homeData.system.piaochuang) || {};
      this.loading = false;
      this.getIsWx(this.userInfo);
    },
    getuserInfo() {
      this.wxLoading = true;
      userinfo()
        .then((response) => {
          this.getIsWx(response);
        })
        .catch(() => {
          this.wxLoading = false;
        });
    },
    getIsWx(val) {
      if (this.userInfo) {
        console.log("%c Line:265 🌶 val.wxCodeState", "color:#4fff4B", val.wxCodeState);
        console.log("%c Line:265 🥛 !val.wxMobile", "color:#fca650", !val.wxMobile);
        if (!val.wxMobile && val.wxCodeState) {
          this.show = true;
          this.wxLoading = false;
          this.$message({
            message: "未查到您的绑定信息,请先扫描二维码，绑定账号及手机号",
            type: "warning",
          });
        } else {
          this.show = false;
          this.wxLoading = false;
        }
      } else {
        this.show = false;
        this.wxLoading = false;
      }
    },
    openclassshow(val) {
      this.classshow = val;
      this.dialogVisible = true;
      setTimeout(() => {
        this.player = new Player({
          id: "video",
          url: this.videoUrl + this.classshow.video,
          videoInit: true,
          width: "100%",
          defaultPlaybackRate: 1,
          loop: false,
          autoplay: false,
        });
      }, 200);
    },

    getHomeInfo() {
      this.loading = true;
      if (this.home && this.home.system) {
        this.applyHomeData(this.home);
        return;
      }
      gethomeinfo()
        .then((response) => {
          this.$store.commit("home", response);
          this.applyHomeData(response);
        })
        .catch(() => {
          this.loading = false;
        });
    },

    loginOut() {
      this.$store.commit("userInfo", false);
      removeToken();
      this.openLogin(0);
    },

    openRouter(val) {
      this.$router.push({ name: val });
    },

    openLogin(val) {
      this.$router.push({ name: "login", params: { id: val } });
    },
  },
  components: {
    piaochuang,
  },
};
</script>

<style>
.lke-lunbo-r-fot img {
  display: none !important;
}

.lke-lunbo-r-fot>p>img {
  display: none !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>

<style scoped>
.lke-lunbo {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
}

.lke-lunbo-l {
  width: 180px !important;
  height: 180px !important;
  padding: 10px;
}

.lke-lunbo-l>img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.lke-lunbo-r {
  padding-left: 20px;
  padding-top: 20px;
  flex: 1;
}

.lke-lunbo-r-top {
  line-height: 40px;
  border-bottom: 1px dashed #c0bbc2;
  font-size: 20px;
  color: #5c5f5c;
}

.lke-lunbo-r-fot {
  padding-top: 20px;
  padding-right: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #333;
}

.lke-lunbo-r-fot img {
  display: none !important;
}

.lke-lunbo-r-fot>p>img {
  display: none !important;
}

.lke-header-login {
  height: 350px;
  background: url("../../assets/login_bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.lke-header-bg {
  width: 924px;
  margin: 0 auto;
  height: 100%;
  background: #ccc;
  display: flex;
  flex-direction: row-reverse;
  padding: 0 50px;
  align-items: center;
  background: url("../../assets/login_bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.lke-header-in {
  height: 250px;
  width: 280px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #2890f4;
}

.login-top {
  padding: 18px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  border-bottom: 1px solid #2890f4;
  color: #2890f4;
  letter-spacing: 1px;
}

.login-fot {
  padding: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  height: 127px;
}

.lke-login-button {
  padding: 6px 18px;
  border-radius: 5px;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.lke-login-button.sut {
  background: #2890f4;
}

.lke-login-button.tea {
  background: #57c6d4;
}

.lke-login-fot>p {
  font-size: 14px;
  line-height: 1.5;
}

.lke-login-fot>p>span {
  font-weight: bold;
  color: #2890f4;
}

.lke-login-fot-fot {
  padding-top: 15px;
}

.lke-look {
  min-width: 1024px;
  width: 100%;
  padding: 40px 0 20px 0;
  background: #ccc;
}

.lke-look-in {
  width: 1024px;
  margin: 0 auto;
  height: 250px;
  display: flex;
  align-items: center;
}

.lke-look-in>div {
  width: 100%;
  background: #fff;
  margin: 0 10px;
  height: 100%;
}

.lke-look-top {
  display: flex;
  justify-content: space-between;
  padding: 20px 30px;
  align-items: center;
}

.lke-look-top>div {
  font-size: 16px;
  cursor: default;
  background: url("../../assets/gonggao_bg.png") no-repeat;
  width: 86px;
  height: 32px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
}

.lke-look-top>a {
  font-size: 12px;
  color: #333;
  cursor: pointer;
}

.lke-look-top>a:hover {
  color: #2890f4;
}

.lke-look-l-fot {
  padding: 0 30px;
  display: flex;
}

.lke-look-l-fot-r {
  margin-left: 10px;
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 130px;
  flex-direction: column;
  justify-content: space-between;
}

.lke-look-l-fot-r p {
  color: #333;
}

.lke-look-l-fot-r p:hover {
  cursor: pointer;
}

.lke-look-l-fot-r-fot {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lke-look-l-fot-r-fot>span {
  color: #d0d0d0;
  cursor: default;
}

.lke-look-l-fot-r-fot div {
  padding: 6px 3px;
  color: #fff;
  background: #166dac;
  font-size: 12px;
  cursor: pointer;
}

.lke-look-r-fot {
  height: 170px;
  margin: 0 30px;
  overflow-x: none;
  overflow-y: scroll;
}

.lke-look-text {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
}

.lke-look-text-l {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  background: #ccc;
  color: #fff;
}

.lke-look-text-l>span:first-child {
  font-size: 20px;
  font-weight: 600;
}

.lke-look-text-l>span:last-child {
  font-size: 12px;
}

.lke-look-text-r {
  padding-left: 20px;
}

.lke-class {
  min-width: 1024px;
  background: url("../../assets/class_bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.lke-class-in {
  width: 1024px;
  margin: 0 auto;
}

.lke-class-top {
  color: #fff;
  text-align: center;
  font-size: 26px;
  letter-spacing: 2px;
  font-weight: 600;
  padding: 30px 0;
}

.lke-class-fot {
  padding: 20px 50px;
  display: flex;
  flex-wrap: wrap;
}

.lke-calss-tab {
  width: 288px;
  margin: 20px 10px;
  cursor: pointer;
}

.lke-calss-tab-top {
  width: 100%;
  height: 0;
  padding-bottom: 70%;
  background: #fff;
}

.lke-calss-tab-fot {
  color: #fff;
  margin-top: 15px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
}

.lke-th-in {
  width: 1024px;
  background: #fff;
  margin: 20px auto;
}

.lke-th-top {
  padding: 20px;
}

.lke-th-titl {
  font-size: 16px;
  cursor: default;
  background: url("../../assets/gonggao_bg.png") no-repeat;
  width: 96px;
  height: 32px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
}

.lke-th-fot {
  display: flex;
  padding: 20px 50px;
}

.lke-th-m {
  flex: 1;
  overflow-x: scroll;
  overflow-y: none;
  display: flex;
  align-items: center;
}

.lke-th-tab {
  padding: 10px;
}

.lke-th-tab>div:last-child {
  text-align: center;
}

.lke-look-text-r {
  color: #333;
}

.lke-look-text:hover>.lke-look-text-l {
  background: #2890f4;
}

.lke-look-text:hover>.lke-look-text-r {
  color: #2890f4;
}

.lke-zhezhao {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lke-zhezhao-box {
  padding: 40px;
  border-radius: 5px;
  background: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/indexPage/indexPage.vue